import { Link, Navigate, Outlet, useParams } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export function ProfileAccessDeniedPage() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center p-8">
      <div className="max-w-md text-center bg-surface rounded-xl border border-border p-8">
        <ShieldAlert className="w-12 h-12 text-warning mx-auto mb-4" aria-hidden />
        <h1 className="text-xl font-semibold text-foreground mb-2">Access denied</h1>
        <p className="text-body-sm text-foreground-muted mb-6">
          You don&apos;t have access to this advertising account. Contact your administrator if you
          need access.
        </p>
        <Link
          to="/accounts"
          className="inline-flex items-center justify-center rounded-lg border border-border bg-surface px-4 py-2 text-sm font-semibold text-foreground-muted hover:bg-surface-muted"
        >
          Back to accounts
        </Link>
      </div>
    </div>
  );
}

export function ProtectedProfileRoute() {
  const { profileId } = useParams<{ profileId: string }>();
  const { canAccessProfile, loading } = useAuth();

  if (loading) return null;

  const pid = profileId ? decodeURIComponent(profileId) : '';
  if (!pid) {
    return <Navigate to="/accounts" replace />;
  }

  if (!canAccessProfile(pid)) {
    return <ProfileAccessDeniedPage />;
  }

  return <Outlet />;
}
